import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-title" }
const _hoisted_2 = { style: {"background-color":"#fff","padding":"16px"} }
const _hoisted_3 = { style: {"padding-bottom":"16px"} }
const _hoisted_4 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_5 = { style: {"margin-left":"10px"} }
const _hoisted_6 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_7 = { style: {"margin-left":"10px"} }
const _hoisted_8 = { class: "dialog-footer" }

import { t, lang } from '@/plugins/i18n'
import { ElMessage } from 'element-plus'
import { ref, reactive } from 'vue'

interface TableContentItem {
  repeatSku: string;
  repeatLine: number[];
}
interface GetTargetPlatformSKUListParams {
  siteStation: 'ko' | 'ja' | 'en';
  plat: 'zozotown' | 'letian' | 'other' | undefined;
  excelTable: Record<string, string>[];
}

export default /*#__PURE__*/_defineComponent({
  emits: ['resetBatchUpload'],
  setup(__props, { expose, emit }) {


const reactiveState = reactive<{
  repatList?: Array<TableContentItem>;
  tipMessage?: string;
}>({})

const dialogVisible = ref(false)

let closeResolve: undefined | ((isOk: boolean) => void)
const closeModal = (isOk: boolean) => {
  closeResolve?.(isOk)
  closeResolve = undefined
  dialogVisible.value = false
  reactiveState.repatList = undefined
  reactiveState.tipMessage = undefined
}
const openModal = () => {
  return new Promise<boolean>((resolve) => {
    closeResolve = resolve
    dialogVisible.value = true
    return true
  })
}

/** 目标平台校验 sku 所需的 map 配置 */
const validateTargetPlatformSKUMap = new Map([
  [
    'ja-zozotown', {
      targetPlatformSKUKey: 'JANコード',
      tipMessage: t('存在重复JANcode')
    }],
  ['ja-letian', {
    targetPlatformSKUKey: '楽天SKU（商品管理コード）',
    tipMessage: t('存在重复的乐天SKU')
  }],
  ['ja-other', {
    targetPlatformSKUKey: 'SKU（商品管理コード）',
    tipMessage: t('存在重复商品SKU')
  }],
  ['ko-other', {
    targetPlatformSKUKey: 'SKU（상품관리코드）',
    tipMessage: t('存在重复商品SKU')
  }],
  ['en-other', {
    targetPlatformSKUKey: 'SKU (Product Management System)',
    tipMessage: t('存在重复商品SKU')
  }]
])

const getTargetPlatformConfig = (params: GetTargetPlatformSKUListParams) => {
  const { siteStation, plat, excelTable } = params
  const targetPlatformName = `${siteStation}-${plat ?? 'other'}`
  const targetPlatformConfig = validateTargetPlatformSKUMap.get(targetPlatformName)
  return targetPlatformConfig
}
// 获取 sku 列表
const getTargetPlatformSKUList = (params: GetTargetPlatformSKUListParams) => {
  const { excelTable } = params
  // const targetPlatformName = `${siteStation}-${plat ?? 'other'}`
  // const targetPlatformConfig = validateTargetPlatformSKUMap.get(targetPlatformName)
  const targetPlatformConfig = getTargetPlatformConfig(params)
  if (!targetPlatformConfig) return
  const targetPlatformSKUList = excelTable.map(item => item[targetPlatformConfig.targetPlatformSKUKey]).filter(Boolean)
  return targetPlatformSKUList
}

// 获取存在重复 sku 列表
const getExistRepeatList = (arr: string[]) => {
  const repeatMap = arr.reduce((pre, cur, index) => {
    pre.set(cur, [...(pre.get(cur) ?? []), index + 2])
    return pre
  }, new Map<string, number[]>())
  const list = [...repeatMap.entries()]
  return list.map(item => {
    return {
      repeatSku: item[0],
      repeatLine: item[1]
    }
  }).filter(item => item.repeatLine.length > 1)
}

const validateTargetPlatformSKURepeat = async (params: GetTargetPlatformSKUListParams) => {
  const skuList = getTargetPlatformSKUList(params)
  const repeatList = getExistRepeatList(skuList!)
  if (!repeatList.length) return
  const config = getTargetPlatformConfig(params)!
  reactiveState.repatList = repeatList
  reactiveState.tipMessage = config.tipMessage
  return openModal()
}

expose({
  validateTargetPlatformSKURepeat
})


return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialogVisible).value = $event)),
    width: 200,
    "show-close": false,
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    "custom-class": "validate-sku-modal"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (closeModal(true)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("继续上传")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (closeModal(false)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('重新上传')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)("注意4")), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)("请确认重复信息，若确认请点击继续上传，否则请重新上传修改后的文件。")), 1),
        _createVNode(_component_el_table, {
          data: _unref(reactiveState).repatList,
          height: "400",
          class: "validate-sku-table"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "repeatLine",
              label: _unref(t)('行目')
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('第X行').replace('X', scope.row.repeatLine)), 1)
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "repeatSku",
              label: _unref(t)('重复信息')
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(reactiveState).tipMessage) + ":  " + _toDisplayString(scope.row.repeatSku), 1)
                ])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["data"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})